var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirdropIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/airdrop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "airdrop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.4376 23.625C30.2501 20.2084 27.2709 17.2291 23.8543 18.0416C22.2501 18.4374 20.9376 19.75 20.5418 21.3542C19.7293 24.7708 22.7084 27.75 26.1251 26.9375C27.7501 26.5416 29.0626 25.2292 29.4376 23.625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.5208 35.8125C41.0833 32.4792 43.3125 27.75 43.3125 22.4791C43.3125 12.3541 35.1042 4.16667 25 4.16667C14.8958 4.16667 6.6875 12.375 6.6875 22.4791C6.6875 27.7708 8.9375 32.5416 12.5417 35.8749",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.6667 30.3125C14.75 28.2708 13.5625 25.5208 13.5625 22.4791C13.5625 16.1666 18.6875 11.0416 25 11.0416C31.3125 11.0416 36.4375 16.1666 36.4375 22.4791C36.4375 25.5208 35.25 28.25 33.3333 30.3125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.4584 34.7083L18.4583 38.4375C16.0833 41.4167 18.1875 45.8125 22 45.8125H27.9792C31.7917 45.8125 33.9167 41.3958 31.5209 38.4375L28.5208 34.7083C26.7292 32.4374 23.2709 32.4374 21.4584 34.7083Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdropIcon);
export default __webpack_public_path__ + "static/media/airdrop-icon.0172b7186be252da82db65c6eb790226.svg";
export { ForwardRef as ReactComponent };